/* CustomWidthPreviewPanelContainer.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3bQTemdnbC%7Binset-block%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1OKFqYN91d%7Binset-inline-end%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02HZdu%7Bwidth%3A1px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pp6NdYbGa%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2OUyjtFYNq%7Bbox-shadow%3Avar(--ds-shadow-overflow%2C0%200%208px%20%231e1f2128%2C0%200%201px%20%231e1f211e)%7D");
import React, { useCallback, useMemo, useRef } from 'react';
import { Panel } from '@atlaskit/navigation-system/layout/panel';
import { PanelSplitter } from '@atlaskit/navigation-system/layout/panel-splitter';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { useCurrentPreviewPanel } from '@atlassian/preview-panels-api/use-current-preview-panel';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { usePreviewPanelsActions } from '@atlassian/preview-panels-api/use-preview-panel-actions';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- jsx is required by the @jsx pragma in this file.

import { AggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment';
const DEFAULT_WIDTH_PERCENTAGE = 50;
const DEFAULT_MIN_OPEN_WIDTH = 420;
const styles = {
  edgeShadow: "_3bQTemdnbC _1mT5xdWVPG _1OKFqYN91d _39xV02HZdu _1pp6NdYbGa _2OUyjtFYNq"
};
type Props = {
  /**
   * Percentage of the viewport the panel opens at and can be stretched to. The
   * opening width is this percentage (floored at `minOpenWidth`); the maximum is the
   * same percentage, passed to the platform Panel as a `vw` bound so the platform
   * clamps the width live in CSS as the window resizes. Defaults to
   * {@link DEFAULT_WIDTH_PERCENTAGE}.
   */
  widthPercentage?: number;
  /**
   * Minimum width, in pixels, the panel opens at. A manually-resized width is kept
   * as-is (not re-floored) so a width dragged below this isn't bumped back up.
   * Defaults to {@link DEFAULT_MIN_OPEN_WIDTH}.
   */
  minOpenWidth?: number;
};

/**
 * Preview panel container with configurable sizing. Opens at, and can be stretched
 * up to, `widthPercentage` of the viewport (floored at `minOpenWidth`) - so it opens
 * at its maximum width and can only be dragged narrower. The max is a `vw` bound the
 * platform clamps live in CSS. A manually-resized width is remembered across
 * close/reopen.
 */
export const CustomWidthPreviewPanelContainer = ({
  widthPercentage = DEFAULT_WIDTH_PERCENTAGE,
  minOpenWidth = DEFAULT_MIN_OPEN_WIDTH
}: Props): React.JSX.Element | null => {
  const panel = useCurrentPreviewPanel();
  const {
    setPanelWidth
  } = usePreviewPanelsActions();

  // Remembers the last width the user dragged to, so the panel reopens at that
  // width instead of the default. Held in a ref (not state) so resizing mid-session
  // doesn't change `defaultWidth` and remount the panel; it's read again on open.
  const lastResizedWidthRef = useRef<number | null>(null);
  const onResizeEnd = useCallback(({
    finalWidth
  }: {
    finalWidth: number;
  }) => {
    lastResizedWidthRef.current = finalWidth;
    setPanelWidth(finalWidth);
  }, [setPanelWidth]);

  // Opening width, resolved once per open (keyed on panel id) so it stays stable
  // while the window is resized mid-session: the last dragged width if the user has
  // resized (kept as-is), otherwise `widthPercentage` of the viewport floored at
  // `minOpenWidth`.
  const defaultWidth = useMemo(() => lastResizedWidthRef.current ?? Math.max(Math.round((typeof window !== 'undefined' ? window.innerWidth : 0) * widthPercentage / 100), minOpenWidth),
  // panel id keeps the opening width stable within a browser session
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [panel?.id, widthPercentage, minOpenWidth]);
  if (!panel) {
    return null;
  }
  const {
    content: PanelContent
  } = panel;
  return <AggRelayEnvironmentProvider>
			<Panel defaultWidth={defaultWidth} maxWidth={`${widthPercentage}vw`}>
				<PanelSplitter label="Resize preview panel" onResizeEnd={onResizeEnd} />
				<div className={ax([styles.edgeShadow])} />
				<PanelContent />
			</Panel>
		</AggRelayEnvironmentProvider>;
};